import React from 'react'

import { useTranslation } from '@/features/locale/LocaleProvider'

export function MarketDataSkeleton({ className }: { className?: string }) {
  return (
    <div
      className={className ?? 'h-20 animate-pulse rounded-lg bg-muted/40'}
      aria-hidden
    />
  )
}

export function MarketDataEmpty({
  message,
  className,
}: {
  message?: string
  className?: string
}) {
  const t = useTranslation()

  return (
    <p className={className ?? 'text-sm text-muted-foreground'}>{message ?? t.common.marketDataEmpty}</p>
  )
}
